import { Observable, of } from 'rxjs';

export class MockActivatedRoute<PAGE_CONFIG_TYPE> {
  snapshot = {
    data: {
      pageConfig: {} as PAGE_CONFIG_TYPE,
    },
  };

  data: Observable<PAGE_CONFIG_TYPE>;

  constructor(pageConfig: PAGE_CONFIG_TYPE) {
    this.snapshot.data.pageConfig = pageConfig;
    this.data = of(pageConfig);
  }
}
